import { render, staticRenderFns } from "./personal.vue?vue&type=template&id=256bfffe&scoped=true&"
import script from "./personal.vue?vue&type=script&lang=js&"
export * from "./personal.vue?vue&type=script&lang=js&"
import style0 from "./personal.vue?vue&type=style&index=0&id=256bfffe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256bfffe",
  null
  
)

export default component.exports